export const headersAlertas = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 5, key: 'status' },
  { text: 'Unidade DAF', width: 10, key: 'dataCriacao' },
  { text: 'Módulo SisAF', width: 15, key: 'tipoDocumento' },
  { text: 'Alerta', width: 7, key: 'extensaoDocumento' },
];

export const valoresExibidosAlerta: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  dataUltimaAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  interfaceSisAf: 'Interface SisAF',
  moduloSisAf: 'Módulo SisAF',
  unidadeDaf: 'Unidade DAF',
  statusAlerta: 'Status',
  dataImplementacao: 'Data da Implementação',
  nomeAlerta: 'Nome do Alerta',
  descricao: 'Descrição',
  observacoes: 'Observações',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  separador: '',
  separadorLog: '',
};

export const fieldObjectAlerta = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
